import React, { useEffect, useState } from 'react';
import { useContext } from 'react';

import Goods from '../../../components/Goods';
import {
  getShopProduct,
  getShopProductCount,
  getMakeShopProductList,
} from '../../../modules/NetworkFunction';
import '../../../index.css';
import AuthContext from '../../../contexts/AuthContext';
import ShopModeContext from '../../../contexts/ShopModeContext';
import Pagination from '../../../components/Pagination';
import faceIcon from '../../../icons/ic-face_gray.png';
import useCafe24Auth from '../../../hooks/useCafe24Auth';

function LinkGoods({ closeModal, handleSelectProduct, userDetail }) {
  const { auth: token } = useContext(AuthContext);
  const { shopMode } = useContext(ShopModeContext);

  const { accessToken } = useCafe24Auth();

  const [productList, setProductList] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState();
  const shopNo = Number(window.localStorage.getItem('shopNo'));
  const mallId = window.localStorage.getItem('mallId');
  const access_token = { token: accessToken, mallId: mallId };
  const [state, setState] = useState({
    selected: '상품 명',
    search: '',
  });
  const [currentPage, setCurrentPage] = useState(1);

  const selectGoods = ['상품 명', '상품 등록일'];

  const handleSelect = (e) => {
    setState({ ...state, selected: e.target.value });
    setCurrentPage(1);
  };
  const handleSearch = (e) => {
    setState({ ...state, search: e.target.value });
    setCurrentPage(1);
  };

  useEffect(() => {
    if (shopMode === 'makeshop') {
      const makeshopDomain = new URL(userDetail.makeshopURL).hostname;
      getMakeShopProductList(
        {
          shopDomain: makeshopDomain,
          shopKey: userDetail.makeshopKey,
        },
        (data) => {
          setProductList(data.list);
        },
        (e) => {
          console.log(e);
        },
        token
      );
    }
    if (shopMode === 'cafe24') {
      if (accessToken) {
        getShopProductCount(
          { ...access_token, shopNo },
          (data) => {
            for (let i = 0; i < data.count / 100; i++) {
              getShopProduct(
                {
                  ...access_token,
                  page: i,
                  shopNo,
                },
                (data) => {
                  let newArr = data.products;
                  setProductList((prev) => {
                    return [...prev, ...newArr];
                  });
                },
                () => {},
                (e) => {
                  console.log(e);
                },
                token
              );
            }
          },
          () => {},
          (e) => {
            console.log(e);
          },
          token
        );
      }
    }
  }, [accessToken, shopMode, shopNo, mallId, token]);

  const filteredProductList = productList?.filter((product) => {
    if (state.search === '') return product;

    if (
      state.selected === '상품 명' &&
      state.search !== '' &&
      product.product_name.toLowerCase().includes(state.search)
    ) {
      return product;
    }
    if (
      state.selected === '상품 등록일' &&
      state.search !== '' &&
      (shopMode === 'cafe24'
        ? product.created_date.includes(state.search)
        : product.regdate.includes(state.search))
    ) {
      return product;
    }

    return null;
  });

  const products = filteredProductList?.map((product, idx) => {
    let start = (currentPage - 1) * 8;

    if (start <= idx && idx < start + 8) {
      return (
        <Goods
          key={shopMode === 'cafe24' ? product.product_no : product.uid}
          product={product}
          handleCheckProduct={() => {
            setSelectedProduct(product);
          }}
          selectedProduct={selectedProduct}
          makeshopURL={userDetail.makeshopURL}
        />
      );
    }
  });

  const empty = (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: 520,
      }}
    >
      <div>
        <img src={faceIcon} />
      </div>
      <div style={{ marginTop: 25 }}>
        <p style={{ color: '#848484', fontSize: 22 }}>
          등록된 상품이 없습니다.
        </p>
      </div>
    </div>
  );

  return (
    <div
      style={{
        width: 1300,
        height: 894,
        borderRadius: 10,
        backgroundColor: 'white',
        paddingTop: 40,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          marginBottom: 47,
          paddingLeft: 30,
        }}
      >
        <p style={{ fontSize: 30, marginRight: 770 }}>상품연결하기</p>
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: 55,
        }}
      >
        <p style={{ marginRight: 60, fontSize: 22 }}>전체 상품</p>
        <select
          name="select"
          onChange={handleSelect}
          value={state.selected}
          style={{
            width: 248,
            height: 52,
            marginRight: 25,
            paddingLeft: 15,
            fontSize: 20,
            color: '#848484',
          }}
        >
          {selectGoods.map(function (n) {
            return (
              <option value={n} key={n}>
                {n}
              </option>
            );
          })}
        </select>
        <input
          type="text"
          style={{ width: 554, height: 50, marginRight: 5, fontSize: 20 }}
          value={state.search}
          onChange={handleSearch}
          placeholder={
            state.selected === '상품 등록일'
              ? 'yyyy-mm-dd 의 형식을 따라주세요.'
              : '검색어를 입력해주세요.'
          }
        />
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          {products?.length === 0 ? (
            empty
          ) : (
            <div
              style={{
                width: '90%',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-between',
                flexWrap: 'wrap',
              }}
            >
              {products}
            </div>
          )}
        </div>

        <Pagination
          itemsPerPage={8}
          currentPage={currentPage}
          totalItems={products?.length}
          paginate={setCurrentPage}
        />

        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              marginRight: 20,
            }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                marginBottom: 47,
              }}
            >
              <button
                style={{
                  marginRight: '20px',
                  width: 120,
                  height: 37,
                  borderRadius: 20,
                  backgroundColor: '#CCCCCC',
                  color: '#4D4D4D',
                  fontSize: 16,
                  borderWidth: 0,
                  cursor: 'pointer',
                  fontWeight: 700,
                }}
                onClick={() => {
                  closeModal();
                }}
              >
                취소
              </button>

              <button
                className={
                  selectedProduct ? 'normal-button-o' : 'normal-button-d'
                }
                style={{
                  width: 120,
                  height: 37,
                  borderRadius: 20,
                  fontSize: 16,
                  borderWidth: 0,
                  fontWeight: 700,
                }}
                disabled={!selectedProduct}
                onClick={() => {
                  closeModal();
                  handleSelectProduct(selectedProduct);
                }}
              >
                저장
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LinkGoods;
